import { motion } from "framer-motion";
import { useI18n } from "../../lib/i18n";

const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    show: (i = 0) => ({
        opacity: 1,
        y: 0,
        transition: { duration: 0.9, delay: i * 0.08, ease: [0.16, 1, 0.3, 1] },
    }),
};

export default function About() {
    const { t } = useI18n();
    const s = t.about;

    return (
        <section
            id="about"
            className="section relative bg-[#050505]"
            data-testid="about-section"
        >
            <div className="container-x">
                <motion.div
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={fadeUp}
                    className="flex items-center gap-3 text-[11px] font-mono uppercase tracking-[0.28em] text-[#E55B13] mb-8"
                >
                    <span className="w-8 h-px bg-[#E55B13]" />
                    {s.eyebrow}
                </motion.div>

                <motion.h2
                    initial="hidden"
                    whileInView="show"
                    viewport={{ once: true, margin: "-100px" }}
                    variants={fadeUp}
                    className="font-heading text-4xl md:text-6xl lg:text-7xl font-light tracking-[-0.03em] leading-[1.02] max-w-5xl"
                >
                    {s.titlePre}
                    <span className="text-[#E55B13]">{s.titleAccent}</span>
                    {s.titlePost}
                </motion.h2>

                <div className="mt-24 md:mt-32 space-y-24 md:space-y-32">
                    {s.chapters.map((c, i) => {
                        const n = String(i + 1).padStart(2, "0");
                        return (
                            <div
                                key={n}
                                className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-12 items-start"
                                data-testid={`about-chapter-${n}`}
                            >
                                <motion.div
                                    initial="hidden"
                                    whileInView="show"
                                    viewport={{ once: true, margin: "-100px" }}
                                    variants={fadeUp}
                                    className="md:col-span-4"
                                >
                                    <div className="chapter-number">{n}</div>
                                    <div className="mt-4 font-mono text-[11px] uppercase tracking-[0.28em] text-white/40">
                                        {s.chapter} · {n}
                                    </div>
                                </motion.div>
                                <motion.div
                                    initial="hidden"
                                    whileInView="show"
                                    viewport={{ once: true, margin: "-100px" }}
                                    variants={fadeUp}
                                    custom={1}
                                    className="md:col-span-8 md:pt-8"
                                >
                                    <h3 className="font-heading text-2xl md:text-4xl font-light tracking-[-0.02em] leading-tight text-white">
                                        {c.title}
                                    </h3>
                                    <p className="mt-5 font-body text-base md:text-lg text-white/60 max-w-xl leading-relaxed">
                                        {c.body}
                                    </p>
                                </motion.div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
